var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-muted"},[_vm._v("The next few questions help us do this.")]),_c('b-button',{attrs:{"block":"","variant":"primary"},on:{"click":function($event){return _vm.next()}}},[_vm._v("Next")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }